"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParameters = exports.getOrGenerateSessionId = exports.deleteCookie = exports.storeAnonymousId = exports.getStoredAnonymousId = exports.setCookie = exports.getCookieFrom = exports.SESSION_ID_KEY = void 0;
const stats_api_1 = __importDefault(require("./stats-api"));
exports.SESSION_ID_KEY = 'SESSION_ID_KEY';
function getCookieFrom(name, cookieString) {
    const matches = cookieString.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
exports.getCookieFrom = getCookieFrom;
function setCookie(name, value, options) {
    const expires = options.expires;
    if (typeof expires === 'string') {
    }
    else {
        options.expires = expires.toUTCString();
    }
    value = encodeURIComponent(value);
    let updatedCookie = name + '=' + value;
    for (const propName in options) {
        updatedCookie += '; ' + propName;
        const propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += '=' + propValue;
        }
    }
    document.cookie = updatedCookie;
}
exports.setCookie = setCookie;
const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
function getStoredAnonymousId() {
    const cookie = document.cookie;
    let anonymousId = getCookieFrom(ANONYMOUS_ID_COOKIE_NAME, cookie);
    if (anonymousId) {
        anonymousId = anonymousId.replace(/"/g, '');
    }
    else {
        anonymousId = undefined;
    }
    return anonymousId;
}
exports.getStoredAnonymousId = getStoredAnonymousId;
function storeAnonymousId(anonymousId) {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    setCookie(ANONYMOUS_ID_COOKIE_NAME, `"${anonymousId}"`, {
        expires: date,
        path: '/',
    });
}
exports.storeAnonymousId = storeAnonymousId;
function deleteCookie(name, options) {
    setCookie(name, '', {
        ...options,
        expires: 'Thu, 01 Jan 1970 00:00:01 GMT',
    });
}
exports.deleteCookie = deleteCookie;
function getOrGenerateSessionId() {
    let sessionID = sessionStorage.getItem(exports.SESSION_ID_KEY) || '';
    if (!sessionID) {
        sessionID = stats_api_1.default.UUID();
        sessionStorage.setItem(exports.SESSION_ID_KEY, sessionID);
    }
    return sessionID;
}
exports.getOrGenerateSessionId = getOrGenerateSessionId;
function getQueryParameters() {
    return location.search;
}
exports.getQueryParameters = getQueryParameters;
//# sourceMappingURL=WebStatUtils.js.map